<template>
  <div>
    <el-dialog
      title="库存流水"
      width="1100px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <div class="flex flex-y-center m-b-10">
          <span class="c-gray">仓库/库位/物料/规格/批号的出入变动明细</span>
          <el-button
            size="mini"
            icon="el-icon-refresh"
            class="m-l-10"
            :disabled="!hasFilter"
            @click="resetFilter"
            >重置筛选
          </el-button>
        </div>
        <vxe-grid
          ref="refTable"
          :loading="loading"
          :columns="tableColumn"
          :data="tableData"
          :height="500"
          @resizable-change="handleColumnResize"
        >
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              :filterData="filterData"
              :value="filterData[column.field]"
              placeholder="输入关键字"
              @change="headerFilterChange"
            />
          </template>
          <template #default_change_qty="{ row }">
            <span :class="Number(row.change_qty) >= 0 ? 'c-green' : 'c-red'">{{ row.change_qty }}</span>
          </template>
          <template #pager>
            <div></div>
            <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="selfShow = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  tableName: 'new_stock_inventory_water',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    cond: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selfShow: false,
      loading: true,
      filterData: {
        material_name: '',
        category: '',
        spec: '',
        batch_no: '',
        flow_no: '',
        source_no: '',
        operator_name: '',
        change_type_str: ''
      },
      sortData: {
        id: 'desc'
      },
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      }
    }
  },
  computed: {
    hasFilter() {
      return Object.keys(this.filterData).some((key) => {
        let val = this.filterData[key]
        return val !== '' && val !== null && val !== undefined
      })
    },
    headerFilterUrl() {
      return '/admin/gcvip/inventory/waterSearchHeard'
    },
    tableColumn() {
      let result = [
        { title: '序号', type: 'seq', width: 40 },
        { title: '流水号', field: 'flow_no', slots: { header: 'header_input' }, width: 160 },
        { title: '仓库', field: 'warehouse_name', width: 100 },
        { title: '库位', field: 'location_name', width: 90 },
        { title: '物料名称', field: 'material_name', slots: { header: 'header_input' } },
        { title: '材质', field: 'category', slots: { header: 'header_input' }, width: 80 },
        { title: '规格(mm)', field: 'spec', slots: { header: 'header_input' }, width: 110 },
        { title: '单位', field: 'unit', width: 50 },
        { title: '变动类型', field: 'change_type_str', slots: { header: 'header_input' }, width: 80 },
        { title: '变动前', field: 'before_qty', width: 80 },
        { title: '变动量', field: 'change_qty', slots: { default: 'default_change_qty' }, width: 80 },
        { title: '变动后', field: 'after_qty', width: 80 },
        { title: '批号', field: 'batch_no', slots: { header: 'header_input' }, width: 110 },
        { title: '来源单号', field: 'source_no', slots: { header: 'header_input' }, width: 130 },
        { title: '操作人', field: 'operator_name', slots: { header: 'header_input' }, width: 80 },
        { title: '时间', field: 'flow_time', width: 150 }
      ]
      this.$util.initTableColumnWidth(this.$options.tableName, result, 'inherit')
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getListData()
  },
  methods: {
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    resetFilter() {
      Object.keys(this.filterData).forEach((key) => {
        this.filterData[key] = ''
      })
      this.searchListData()
    },
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    getListData() {
      this.loading = true
      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        warehouseId: this.cond.warehouseId,
        locationId: this.cond.locationId,
        skuId: this.cond.skuId,
        filterData: this.filterData,
        sortData: this.$util.deepCopy(this.sortData)
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/inventory/waterList',
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            this.tableData = this.$util.deepCopy(data.list) || []
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
